let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hIs61")).then(() => parcelRequire('aWV53'));